import { type Context, createContext } from 'react';

export const WindowLocationContext: Context<string | null> = createContext<string | null>(null);
